export default __webpack_public_path__ + "static/media/phone.307b531c.svg";